import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';

/**
 * Sets up a MutationObserver to ensure all product links open in new tabs
 * This improves user experience by preventing navigation away from the chat
 */
function setupProductLinksObserver() {
  // Create a MutationObserver to watch for new product links
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        // Look for product links in added nodes
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Only process Element nodes
            const element = node as Element;
            // Find all links inside the added node
            const links = element.querySelectorAll('a[href]');
            
            links.forEach((link) => {
              // Clone the link to remove all existing event listeners
              const oldLink = link;
              const newLink = oldLink.cloneNode(true) as HTMLAnchorElement;
              
              // Add target="_blank" attribute
              newLink.setAttribute('target', '_blank');
              newLink.setAttribute('rel', 'noopener noreferrer');
              
              // Add click event handler to force new tab
              newLink.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                window.open(newLink.href, '_blank', 'noopener,noreferrer');
              });
              
              // Replace old link with new link
              if (oldLink.parentNode) {
                oldLink.parentNode.replaceChild(newLink, oldLink);
              }
            });
          }
        });
      }
    });
  });

  // Start observing the document for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', setupProductLinksObserver);

/**
 * Render the React application to the DOM
 * Wraps the App component in StrictMode for additional checks in development
 */
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
